module.exports = __webpack_public_path__ + "img/空白（纯页码居左）.f2ecb6e3.jpg";